import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/order-types/wb.png'


const _hoisted_1 = {
  key: 0,
  class: "OrderType__disabled"
}
const _hoisted_2 = {
  key: 2,
  class: "OrderType__subtitle"
}
const _hoisted_3 = { class: "content__header" }
const _hoisted_4 = { class: "header__info" }
const _hoisted_5 = {
  key: 0,
  class: "ozon"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  alt: "WB",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_info = _resolveComponent("icon-info")!
  const _component_icon_ozon = _resolveComponent("icon-ozon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", {
    class: ["OrderType", {
            'OrderType--LTL': _ctx.type === 'LTL',
            'OrderType--FTL': _ctx.type === 'FTL',
            'OrderType--Express': _ctx.type === 'Express',
            'OrderType--Purple': _ctx.type === 'Purple',
            'OrderType--Green': _ctx.type === 'Green',
            'OrderType--Landing': _ctx.type === 'Landing',
            'OrderType--disabled': _ctx.disabled,
        }],
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    (_ctx.disabled)
      ? (_openBlock(), _createBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (Boolean(_ctx.img))
      ? (_openBlock(), _createBlock("img", {
          key: 1,
          class: "OrderType__img",
          src: _ctx.getImage(_ctx.img),
          alt: _ctx.type,
          style: {
                top: _ctx.imageTop,
                bottom: _ctx.imageBottom,
                right: _ctx.imageRight,
                left: _ctx.imageLeft,
                width: _ctx.imageWidth,
                height: _ctx.imageHeight,
            }
        }, null, 12, ["src", "alt"]))
      : _createCommentVNode("", true),
    (_ctx.subtitle)
      ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.subtitle), 1))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: ['OrderType__content', { relative: _ctx.isRelativeContent }]
    }, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h2", {
          class: ["header__title", { 'title--purple': _ctx.type === 'OZON' }],
          style: { maxWidth: _ctx.titleMaxWidth ? `${_ctx.titleMaxWidth}px` : null }
        }, _toDisplayString(_ctx.title), 7),
        _withDirectives(_createVNode("div", _hoisted_4, [
          (Boolean(_ctx.hint))
            ? (_openBlock(), _createBlock(_component_icon_info, {
                key: 0,
                class: ["header__info", { 'info--purple': _ctx.type === 'OZON' }]
              }, null, 8, ["class"]))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_tooltip, { text: _ctx.hint, theme: { direction: 'bottom' } }]
        ])
      ]),
      (_ctx.type === 'OZON')
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_icon_ozon),
            _hoisted_6
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}